"use client";

import React from "react";
import { Flame, ChartPie, Shield, Megaphone, TrendingUp } from "lucide-react";
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const pillars = [{
  icon: TrendingUp,
  title: "Hogere personeelsinzet",
  description: "Teveel uren, inefficiënte planning en onnodig hoge loonkosten.",
  image: null
}, {
  icon: ChartPie,
  title: "Geen grip op cijfers",
  description: "Weinig inzicht in marges, kosten en in wat er écht overblijft.",
  image: null
}, {
  icon: Flame,
  title: "De dagelijkse drukte\nneemt alles over",
  description: "Geen tijd en ruimte om te bouwen aan groei en verbetering.",
  image: null
}, {
  icon: Megaphone,
  title: "Marketing krijgt weinig aandacht",
  description: "\xA0Waardoor zichtbaarheid, nieuwe gasten en extra omzet achterblijven.\n\n",
  image: null
}];
export default function TheHellzEdge() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="223925" id="the-performance-gap" className="bg-background text-foreground py-16 md:py-20 px-4 md:overflow-visible md:h-[600px] md:max-h-none md:px-8">
      <div className="max-w-7xl mx-auto md:h-[400px] h-auto">
        <div ref={ref} className={`text-center mb-16 transition-all duration-700 transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="font-bold font-default text-foreground !not-italic !text-2xl">
            Een horecazaak runnen wordt steeds complexer
          </h2>
        </div>

        <div className="grid grid-cols-2 gap-4 ![padding:0px_0px_50px_0px] md:grid-cols-2 lg:grid-cols-4">
          {pillars.map((pillar, i) => {
          const Icon = pillar.icon;
          return <div key={i} data-index={i} className={`flex flex-col transition-all duration-500 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`} style={{
            transitionDelay: `${i * 150}ms`
          }}>
                

                <Card className="py-6 text-card-foreground flex flex-col gap-6 rounded-xl rounded-t-none rounded-b-xl border-t-0 border-border/50 backdrop-blur-xl transition-all duration-500 flex-grow bg-primary-foreground !p-0 md:!h-[265px] h-auto hover:scale-[1.02] hover:border-primary/30 hover:shadow-xl hover:shadow-primary/10">
                  <div className="flex items-center justify-center pt-4">
                    <Icon className="w-12 h-12 text-primary" />
                  </div>
                  <CardHeader className="pt-2 pb-2 text-center">
                    <CardTitle className="text-xl font-bold font-default text-foreground">
                      {pillar.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent className="text-center ![padding:0px_24px_0px_24px]">
                    <CardDescription className="text-base text-muted-foreground leading-relaxed font-sans">
                      {pillar.description}
                    </CardDescription>
                  </CardContent>
                </Card>
              </div>;
        })}
        </div>

        <div className="text-center transition-all duration-700 delay-700 transform opacity-100 translate-y-0 flex flex-col gap-4">
          <div className="![padding:8px_0px_0px_0px]">
            <p className="font-semibold text-foreground mb-2 !text-4xl">
              Wij brengen structuur, strategie en groei samen
            </p>
          </div>
          <div className="![padding:0px_0px_8px_0px]">
            <p className="text-primary font-medium !text-xl">
              als jouw strategisch partner achter de schermen.
            </p>
          </div>
          <div className="mt-4 h-px w-full max-w-2xl mx-auto bg-border/50" />
        </div>
      </div>
    </section>;
}